import { render, staticRenderFns } from "./lt-feed-item.vue?vue&type=template&id=636735a4&scoped=true&"
import script from "./lt-feed-item.vue?vue&type=script&lang=js&"
export * from "./lt-feed-item.vue?vue&type=script&lang=js&"
import style0 from "./lt-feed-item.vue?vue&type=style&index=0&id=636735a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636735a4",
  null
  
)

export default component.exports